import React, { useState, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import logo from './assets/logo.png';
import axios from 'axios';
import Jobs from './pages/Jobs';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Partnership from './pages/Partnership';
import Internship from './pages/Internship';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import PartnerLogin from './pages/PartnerLogin';
import PartnerDashboard from './pages/PartnerDashboard';
import StaffDashboard from './pages/StaffDashboard';
import Navbar from './Navbar';
import AnniversaryBadge from './components/AnniversaryBadge';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const initialRegistrationForm = {
  name: '',
  email: '',
  place: '',
  contact_number: '',
  whatsapp_number: '',
  district: '',
  highest_qualification: '',
  expecting_job: '',
  department: '',
  section: '',
  resume: null,
  photo: null
};
import './index.css';

// ── Registration form data lists ─────────────────────────────────────────────
const KERALA_PLACES = [
  // Thiruvananthapuram
  'Thiruvananthapuram','Kazhakoottam','Attingal','Neyyattinkara','Nedumangad','Varkala','Kattakada','Nemom','Kovalam','Vizhinjam','Karamana','Sreekaryam','Pattom','Kowdiar','Peroorkada','Parassala','Pothencode','Venganoor','Aruvippuram','Thumba','Thiruvallam','Ulloor','Balaramapuram','Pangode','Kazhakuttam','Technopark','Fort','Palayam','Vanchiyoor','Thampanoor','Anayara',
  // Kollam
  'Kollam','Punalur','Karunagappally','Kottarakkara','Paravur','Kottiyam','Ayoor','Kundara','Perinad','Chadayamangalam','Chavara','Sasthamkotta','Mynagappally','Kulathupuzha','Anchal','Ummannoor',
  // Pathanamthitta
  'Pathanamthitta','Adoor','Thiruvalla','Ranni','Pandalam','Kozhencherry','Konni','Mallappally','Maramon','Aranmula','Chengannur','Tiruvalla','Vennikulam','Puthuppally','Niranam','Elanthoor',
  // Alappuzha
  'Alappuzha','Alleppey','Cherthala','Kayamkulam','Harippad','Mannar','Ambalappuzha','Mavelikkara','Changanassery','Pandanad','Kainakary','Purakkad','Kuttanad','Haripad','Aryankavu','Karuvatta','Muttar',
  // Kottayam
  'Kottayam','Changanacherry','Pala','Vaikom','Muvattupuzha','Erattupetta','Kanjirappally','Ettumanoor','Mundakayam','Ponkunnam','Karukachal','Athirampuzha','Kumarakom','Thodupuzha','Meenachil','Kanjirappally','Kudamaloor',
  // Idukki
  'Thodupuzha','Munnar','Kattappana','Adimali','Neriyamangalam','Painavu','Rajakkad','Devikulam','Nedumkandam','Upputhara','Vandiperiyar','Kumily','Peermade','Udumbanchola','Idukki','Azhutha',
  // Ernakulam
  'Kochi','Ernakulam','Aluva','Angamaly','Perumbavoor','Kothamangalam','Thrippunithura','Kalamassery','Edappally','Kakkanad','Vytilla','Fort Kochi','Mattancherry','Elamakkara','Kaloor','Palarivattom','Vyttila','Maradu','Eloor','North Paravur','Munambam','Koovappady','Piravom','Varappuzha','Kadamakudy','Cheranalloor','Mulanthuruthy','Okkal','Kuruppampady','Manjapra','Chottanikkara','Karumalloor','Njarakkal','Keerampara','Rayamangalam',
  // Thrissur
  'Thrissur','Irinjalakuda','Chalakudy','Guruvayur','Kodungallur','Kunnamkulam','Mala','Wadakkanchery','Chavakkad','Kecheri','Valapad','Pavaratty','Pariyaram','Puthukkad','Nadathara','Ollur','Cherpu','Arimpur','Pongam','Thrissur Town','Viyyur','Perinjanam','Pazhayannur','Mathilakam','Chowannur','Manalur',
  // Palakkad
  'Palakkad','Ottapalam','Shoranur','Mannarkkad','Pattambi','Alathur','Chittur','Nemmara','Kongad','Kalpathy','Malampuzha','Mundur','Sreekrishnapuram','Vadakkencherry','Thrithala','Puthunagaram','Perinthalmanna','Lakkidi','Attappadi','Kuzhalmannam','Parali','Shornur',
  // Malappuram
  'Malappuram','Manjeri','Tirur','Perinthalmanna','Kondotty','Nilambur','Ponnani','Kottakkal','Areekode','Tanur','Valanchery','Tirurrangadi','Vengara','Parappanangadi','Tirurangadi','Kalpakanchery','Edappal','Tenhipalam','Karuvarakundu','Thiruvali','Pulikkal','Angadipuram',
  // Kozhikode
  'Kozhikode','Calicut','Vadakara','Koyilandy','Ramanattukara','Feroke','Beypore','Thamarassery','Mukkam','Thiruvambadi','Kunnamangalam','Narikkuni','Chelannur','Koduvally','Perambra','Mavoor','Kallachi','Balussery','Koorachundu','Payyoli','Quilandy','Vatakara',
  // Wayanad
  'Kalpetta','Mananthavady','Sulthan Bathery','Vythiri','Ambalavayal','Meenangadi','Padinharethara','Panamaram','Noolpuzha','Pulpally','Kambalakad','Meppadi','Kaniyambetta','Begur','Poothadi',
  // Kannur
  'Kannur','Thalassery','Payyannur','Iritty','Koothuparamba','Anthoor','Mattannur','Chelora','Valapattanam','Dharmadom','Chala','Pattuvam','Peravoor','Kalliasseri','Taliparamba','Sreekandapuram','Payyanur','Chapparapadavu','Thripangottur','Azhikkal',
  // Kasaragod
  'Kasaragod','Kanhangad','Manjeshwaram','Nileshwar','Hosdurg','Cheruvathur','Udma','Bekal','Vidyanagar','Ajanur','Badiadka','Kasaragod Town','Mogral Puthur','Valiyaparamba','Trikaripur','Pilicode',
];

const QUALIFICATIONS = [
  'SSLC / 10th','Plus Two / +2 / Higher Secondary','Plus Two - Science','Plus Two - Commerce','Plus Two - Humanities / Arts',
  'ITI (Industrial Training)','Diploma in Engineering','Diploma in Computer Applications (DCA)','Diploma in Pharmacy','Diploma in Nursing','Diploma in Hotel Management',
  'B.A. (Bachelor of Arts)','B.Com (Bachelor of Commerce)','B.Sc (Bachelor of Science)','BBA (Bachelor of Business Administration)','BCA (Bachelor of Computer Applications)',
  'B.Tech (Bachelor of Technology)','B.E. (Bachelor of Engineering)','B.Arch (Bachelor of Architecture)','B.Ed (Bachelor of Education)',
  'B.Pharm (Bachelor of Pharmacy)','B.Sc Nursing','BHM (Bachelor of Hotel Management)','LLB (Bachelor of Laws)',
  'B.P.T. (Physiotherapy)','BAMS (Ayurveda)','BHMS (Homeopathy)','MBBS','BDS (Dental)','B.Sc Psychology','B.Sc Agriculture','B.Sc Microbiology','B.Sc Biochemistry',
  'M.A. (Master of Arts)','M.Com (Master of Commerce)','M.Sc (Master of Science)','MBA (Master of Business Administration)',
  'MCA (Master of Computer Applications)','M.Tech (Master of Technology)','M.E. (Master of Engineering)',
  'M.Ed (Master of Education)','M.Pharm','M.Sc Nursing','LLM (Master of Laws)',
  'MD (Doctor of Medicine)','MS (Master of Surgery)','MDS (Dental Surgery)','M.Arch',
  'PGDM (Post Graduate Diploma in Management)','Post Graduate Diploma','Ph.D',
  'CA Foundation','CA Intermediate','CA Final (Chartered Accountant)',
  'CMA Foundation','CMA Intermediate','CMA Final (Cost Accountant)',
  'CS Foundation','CS Executive','CS Professional (Company Secretary)',
  'ACCA (UK)','CFA (Chartered Financial Analyst)','CFP (Certified Financial Planner)',
  'Certificate Course (Computer)','Certificate Course (Other)',
];

const JOB_ROLES = [
  'Accountant','Accounts Assistant','Accounts Executive','Accounts Payable Specialist','Accounts Receivable Specialist',
  'Administrative Assistant','Administrative Executive','Area Sales Manager','Architect','Auditor','AutoCAD Operator',
  'Backend Developer','Bank Clerk','Bank PO','BDM (Business Development Manager)','BDE (Business Development Executive)',
  'Branch Manager','Business Analyst','CA Article Assistant','Call Centre Executive','Cashier','Chef / Cook',
  'Civil Engineer','Civil Site Engineer','Clinical Pharmacist','CNC Machine Operator','Computer Hardware Technician',
  'Computer Operator','Content Writer','Corporate Trainer','Cost Accountant','Counter Sales Executive','Credit Officer',
  'Customer Relationship Manager','Customer Service Executive','Data Analyst','Data Entry Operator',
  'Digital Marketing Executive','Driver','Electrical Engineer','Electrical Technician','Electronics Engineer',
  'Electronics Technician','Estimator (Civil)','Executive Assistant','Export/Import Executive','Factory Worker',
  'Field Sales Executive','Finance Executive','Finance Manager','Front Office Executive','Full Stack Developer',
  'General Manager','Graphic Designer','GST Consultant','HR Executive','HR Manager','HVAC Technician',
  'Interior Designer','IT Support Engineer','Junior Accountant','Junior Engineer','Junior Software Developer',
  'Lab Technician','Loan Officer','Logistics Executive','Machine Operator','Management Trainee','Manager',
  'Marketing Executive','Marketing Manager','Mechanical Engineer','Medical Representative','Merchandiser',
  'Network Administrator','Nurse (GNM / B.Sc)','Office Assistant','Operations Executive','Operations Manager',
  'Pharmacist','Plumber','Production Engineer','Production Supervisor','Project Coordinator','Project Manager',
  'Purchase Executive','Purchase Manager','Quality Analyst','QA Engineer','Quality Control Inspector',
  'Radiographer','Receptionist','Regional Sales Manager','Safety Officer','Sales Coordinator','Sales Executive',
  'Sales Manager','SAP Consultant','Security Guard','SEO Executive','Site Engineer','Social Media Manager',
  'Software Developer','Software Tester / QA','Store Incharge','Store Keeper','Supervisor',
  'System Administrator','Tax Consultant','Teacher / Faculty','Team Leader','Technician','Telecaller',
  'Transport Manager','UI/UX Designer','Videographer / Photographer','Warehouse Executive',
  'Web Developer','Welder','X-Ray Technician','Zonal Manager',
];

const DEPARTMENTS = [
  'Accounts & Finance','Administration','Audit & Compliance','Banking & Finance','Business Development',
  'Civil Engineering','CNC Machine Operations','Computer Science & IT','Content & Communication',
  'Customer Service & Support','Data Analytics & MIS','Design & Architecture','Digital Marketing',
  'Education & Training','Electrical Engineering','Electronics & Instrumentation','Export & Import',
  'Fabrication & Welding','Field Operations','Finance & Taxation','FMCG / Retail',
  'Front Office & Hospitality','HR & Payroll','Insurance','Legal','Logistics & Supply Chain',
  'Maintenance & Repair','Manufacturing & Production','Marketing & Branding','Mechanical Engineering',
  'Medical & Healthcare','NBFC & Microfinance','Operations','Pharmacy','Purchase & Procurement',
  'Quality Control & QA','Research & Development','Sales','Security','Software Development',
  'Stores & Inventory','Tele Marketing & Call Centre','Transport & Delivery','Warehouse & Dispatch',
];

const DEPT_SECTIONS = {
  'Accounts & Finance': ['Accounts Payable','Accounts Receivable','Billing & Invoicing','Bank Reconciliation','Budgeting & Forecasting','Cost Accounting','Financial Reporting','GST & Taxation','Tally Operations','Payroll Processing','Internal Audit','MIS Reporting'],
  'Civil Engineering': ['Site Supervision','Drawing & Estimation','Structural Design','AutoCAD','BOQ Preparation','MEP Works','Quality & Safety','Project Management','Survey & Layout','Tendering'],
  'Software Development': ['Frontend Development','Backend Development','Full Stack Development','Mobile App Development','QA & Testing','DevOps','Database Administration','UI/UX Design','Cybersecurity','Cloud Computing','API Development'],
  'Computer Science & IT': ['Software Development','Network Administration','Database Administration','IT Support & Helpdesk','Cybersecurity','Cloud & Infrastructure','Business Analysis','ERP Implementation'],
  'HR & Payroll': ['Recruitment & Staffing','Training & Development','Payroll Processing','Employee Relations','Performance Management','Compliance & Labour Law','Induction & Onboarding','HR MIS'],
  'Sales': ['Field Sales','Retail Sales','B2B Sales','Tele Sales','Pre-Sales','After-Sales Support','Sales Coordination','Channel Sales','Counter Sales'],
  'Marketing & Branding': ['Digital Marketing','SEO & SEM','Social Media Marketing','Brand Management','Content Marketing','Offline Marketing','Lead Generation','Market Research','Advertising & Promotions'],
  'Manufacturing & Production': ['Production Planning','Quality Control','Stores','Safety','Process Control','Assembly','Finishing','Packing & Dispatch','Machine Operations'],
  'Mechanical Engineering': ['Design & CAD','Maintenance','Production','Quality Inspection','Fabrication','Tool Room','CNC Programming','HVAC','Welding & Fitting'],
  'Electrical Engineering': ['Power Distribution','Wiring & Installation','PLC/SCADA','Panel Building','Maintenance','Quality & Testing','Project Supervision'],
  'Customer Service & Support': ['Customer Relations','After-Sales Support','Technical Support','CRM','Feedback & Escalation','Chat Support','Email Support'],
  'Logistics & Supply Chain': ['Procurement','Warehouse Management','Dispatch & Delivery','Fleet Management','Import & Export','Inventory Control','Order Processing'],
  'Banking & Finance': ['Loans & Advances','Deposits','Teller Operations','KYC & AML','Insurance Bancassurance','Treasury','Credit Appraisal','Recovery & Collections'],
  'Medical & Healthcare': ['OPD / Outpatient','ICU / Critical Care','Emergency','Lab & Pathology','Pharmacy','Radiology & Imaging','Nursing Station','Operation Theatre','Admin & Medical Records'],
  'Administration': ['Office Management','Facilities Management','Reception & Front Desk','Documentation & Filing','Travel & Logistics','Procurement & Vendor Management','Executive Support'],
  'Business Development': ['Lead Generation','Client Acquisition','Proposal Writing','Market Expansion','Partnerships & Alliances','Key Account Management','Pricing & Negotiation'],
  'Digital Marketing': ['SEO','SEM / Google Ads','Social Media Marketing','Email Marketing','Content Creation','Video Marketing','Analytics & Reporting','Affiliate Marketing'],
  'Purchase & Procurement': ['Vendor Development','Tender & Quotation','Purchase Order Management','Material Planning','Import Procurement','Contract Management','Cost Negotiation'],
  'Warehouse & Dispatch': ['Receiving & Inspection','Storage & Bin Management','Picking & Packing','Dispatch Operations','Inventory Audit','Returns Processing'],
  'Stores & Inventory': ['Stock Management','Material Issue & Receipt','Inventory Control','Bin Card Maintenance','Spares Management'],
  'Quality Control & QA': ['Incoming Quality','In-Process Quality','Final Inspection','Documentation & Audit','Lab Testing','Calibration','ISO Compliance','NABL'],
  'Audit & Compliance': ['Internal Audit','Statutory Audit','Tax Audit','GST Compliance','ROC Filings','Risk Assessment','Process Audit'],
  'Finance & Taxation': ['Income Tax','GST','TDS & TCS','Financial Analysis','Investment Advisory','Audit Support'],
  'Education & Training': ['Teaching (Primary)','Teaching (Secondary)','Teaching (Higher Education)','Technical Training','Soft Skills Training','E-Learning','Administration','Library'],
  'NBFC & Microfinance': ['Business Correspondent','Loan Origination','Field Collection','Recovery','Branch Operations','Credit Analysis','Customer Onboarding'],
  'Front Office & Hospitality': ['Reception','Reservations','Guest Relations','Concierge','Food & Beverage Service','Housekeeping','Banquet Operations'],
  'Design & Architecture': ['Architectural Design','3D Modelling & Rendering','AutoCAD Drawing','Interior Design','Landscape Design','Urban Planning','Graphic Design'],
  'Insurance': ['Life Insurance','General Insurance','Health Insurance','Motor Insurance','Claims Processing','Underwriting','Agency Development'],
  'Legal': ['Corporate Law','Civil Litigation','Criminal Law','Property & Conveyancing','Labour Law','Intellectual Property','Contract Drafting'],
  'Transport & Delivery': ['Local Delivery','Intercity Transport','Fleet Operations','Route Planning','Vehicle Maintenance','Documentation'],
  'CNC Machine Operations': ['CNC Turning','CNC Milling','CNC Programming (G-Code)','Tool Setting','Quality Inspection','Machine Maintenance'],
  'Fabrication & Welding': ['MIG Welding','TIG Welding','ARC Welding','Sheet Metal Fabrication','Structural Fabrication','Gas Cutting','Quality Inspection'],
  'Field Operations': ['Field Survey','Site Operations','Field Sales','Maintenance & Repair','Ground Operations','Data Collection'],
  'Security': ['Premises Security','Access Control','CCTV Monitoring','Patrolling','Fire Safety','VIP Protection'],
  'Content & Communication': ['Content Writing','Copywriting','Technical Writing','Proofreading & Editing','Social Media Content','Video Scripting','PR & Media'],
  'Data Analytics & MIS': ['MIS Reporting','Data Entry & Cleansing','Dashboard & Visualisation','Advanced Excel','Power BI','SQL & Database','Python / R Analytics'],
  'Electronics & Instrumentation': ['PCB Design','Embedded Systems','Industrial Instrumentation','PLC Programming','Maintenance','Testing & QC'],
  'Export & Import': ['Customs Clearance','Shipping Documentation','Freight Coordination','Letter of Credit','Export Compliance','Trade Finance'],
  'Pharmacy': ['Dispensing','Drug Store Management','Clinical Pharmacy','Regulatory Affairs','Quality Assurance','Pharmacovigilance'],
  'Research & Development': ['Product Development','Process Research','Market Research','Testing & Validation','Documentation & Patents'],
  'Tele Marketing & Call Centre': ['Inbound Support','Outbound Sales','Lead Generation','Customer Retention','Collections','Technical Helpdesk'],
  'Maintenance & Repair': ['Preventive Maintenance','Breakdown Maintenance','Civil Maintenance','Electrical Maintenance','Mechanical Maintenance','AMC Coordination'],
  'FMCG / Retail': ['Store Operations','Inventory Management','Merchandising','Sales Floor','Category Management','Vendor Relations'],
};
const ALL_SECTIONS = [...new Set(Object.values(DEPT_SECTIONS).flat())].sort();

function App() {
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(initialRegistrationForm);
  const registerFormRef = useRef(null);

  const openRegisterModal = () => setShowRegisterForm(true);
  const closeRegisterModal = () => setShowRegisterForm(false);

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === 'file') {
      const file = files && files[0] ? files[0] : null;
      setForm(prev => ({ ...prev, [name]: file }));
      return;
    }
    if (name === 'contact_number' || name === 'whatsapp_number') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
      setForm(prev => ({ ...prev, [name]: digitsOnly }));
      return;
    }
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(form.contact_number)) {
      alert('Contact Number must be exactly 10 digits.');
      return;
    }
    if (!/^\d{10}$/.test(form.whatsapp_number)) {
      alert('Whatsapp Number must be exactly 10 digits.');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('name', form.name);
      formData.append('email', form.email);
      formData.append('place', form.place);
      formData.append('contact_number', form.contact_number);
      formData.append('whatsapp_number', form.whatsapp_number);
      formData.append('district', form.district);
      formData.append('highest_qualification', form.highest_qualification);
      formData.append('expecting_job', form.expecting_job);
      formData.append('department', form.department);
      formData.append('section', form.section);
      if (form.resume) formData.append('resume', form.resume);
      if (form.photo) formData.append('photo', form.photo);

      await axios.post(`${API_URL}/api/register`, formData);
      setForm(initialRegistrationForm);
      setShowRegisterForm(false);
      setShowSuccessDialog(true);
    } catch (err) {
      alert(err?.response?.data?.error || 'Failed to save registration.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Router>
      <Navbar openRegisterModal={openRegisterModal} />
      <AnniversaryBadge />
      <div className="pt-16">
        <Routes>
          <Route path="/" element={<Home openRegisterModal={openRegisterModal} />} />
          <Route path="/jobs" element={<Jobs openRegisterModal={openRegisterModal} />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/partnership" element={<Partnership />} />
          <Route path="/internship" element={<Internship />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/partner-login" element={<PartnerLogin />} />
          <Route path="/partner" element={<PartnerDashboard />} />
          <Route path="/staff" element={<StaffDashboard />} />
        </Routes>
      </div>

      {/* Registration Modal (global) */}
      <div className={`${showRegisterForm ? 'fixed' : 'hidden'} inset-0 z-50 bg-black/65 backdrop-blur-sm overflow-y-auto p-2 md:p-4`}>
        <div ref={registerFormRef} className="min-h-full flex items-center justify-center">
          <div className="w-full max-w-7xl min-h-[96vh] md:min-h-[92vh] rounded-[28px] border border-yellow-300/60 bg-white shadow-[0_35px_90px_rgba(0,0,0,0.28)] overflow-hidden">
            <div className="grid grid-cols-1 xl:grid-cols-[0.8fr_1.2fr] min-h-[96vh] md:min-h-[92vh]">
              <div className="relative hidden xl:flex flex-col justify-between overflow-hidden bg-gradient-to-br from-black via-neutral-900 to-yellow-500 px-7 py-7 text-white">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,214,10,0.30),transparent_28%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.10),transparent_30%)]" />
                <div className="relative">
                  <p className="text-sm font-extrabold uppercase tracking-[0.32em] text-yellow-300">Talent Registration</p>
                  <h2 className="mt-5 text-4xl font-extrabold leading-tight">Join Dani Job Club with a profile that is ready to move.</h2>
                  <p className="mt-5 text-[15px] leading-7 text-white/85">
                    Complete the form with your core details, qualification, target role, and supporting files. The updated layout is built to fit the screen properly and stay easy to use.
                  </p>
                </div>
                <div className="relative grid grid-cols-1 gap-4 mt-8">
                  <div className="rounded-[24px] border border-white/15 bg-white/10 px-5 py-4 backdrop-blur-sm">
                    <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-yellow-300">What You Add</p>
                    <p className="mt-2 text-base font-bold leading-7">Profile details, contact info, qualification, expected job, resume and photo.</p>
                  </div>
                  <div className="rounded-[24px] border border-white/15 bg-white/10 px-5 py-4 backdrop-blur-sm">
                    <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-yellow-300">Why It Helps</p>
                    <p className="mt-2 text-base font-bold leading-7">A complete registration is easier to review, filter, and forward for the right openings.</p>
                  </div>
                </div>
              </div>
              <div className="flex min-h-0 flex-col bg-white">
                <div className="flex items-start justify-between gap-4 border-b border-gray-200 px-4 py-4 md:px-6 md:py-4 shrink-0">
                  <div>
                    <p className="text-xs md:text-sm font-extrabold uppercase tracking-[0.28em] text-yellow-500">Register Now</p>
                    <h2 className="mt-2 text-2xl md:text-3xl font-extrabold text-black">Talent Registration Form</h2>
                    <p className="mt-2 text-sm text-gray-600">Full-view layout with smooth scrolling through the complete form.</p>
                  </div>
                  <button
                    type="button"
                    onClick={closeRegisterModal}
                    className="shrink-0 rounded-full border border-gray-300 px-4 py-2 text-sm font-bold text-black hover:border-yellow-400 hover:text-yellow-600 transition"
                  >
                    Close
                  </button>
                </div>
                <form onSubmit={handleSubmit} className="min-h-0 flex flex-col">
                  <div className="modal-scrollbar flex-1 overflow-y-scroll px-4 py-4 pr-2 md:px-6 md:py-5 md:pr-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3.5">
                      <label className="block">
                        <span className="text-sm font-bold text-black">Full Name</span>
                        <input
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          placeholder="Enter your full name"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Email ID</span>
                        <input
                          type="email"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          placeholder="Enter your email address"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Place</span>
                        <input
                          name="place"
                          value={form.place}
                          onChange={handleChange}
                          placeholder="Enter your place"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          list="dl-place"
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Contact Number</span>
                        <input
                          name="contact_number"
                          value={form.contact_number}
                          onChange={handleChange}
                          placeholder="Enter your contact number"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          maxLength={10}
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Whatsapp Number</span>
                        <input
                          name="whatsapp_number"
                          value={form.whatsapp_number}
                          onChange={handleChange}
                          placeholder="Enter your WhatsApp number"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          maxLength={10}
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">District</span>
                        <input
                          name="district"
                          value={form.district}
                          onChange={handleChange}
                          placeholder="Type or select your district"
                          list="district-list"
                          autoComplete="off"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          required
                        />
                        <datalist id="district-list">
                          <optgroup label="Kerala">
                            {['Thiruvananthapuram','Kollam','Pathanamthitta','Alappuzha','Kottayam','Idukki','Ernakulam','Thrissur','Palakkad','Malappuram','Kozhikode','Wayanad','Kannur','Kasaragod'].map(d => <option key={d} value={d} />)}
                          </optgroup>
                          <optgroup label="Tamil Nadu">
                            {['Chennai','Coimbatore','Madurai','Tiruchirappalli','Salem','Tirunelveli','Tiruppur','Ranipet','Vellore','Erode','Thoothukudi','Dindigul','Thanjavur','Sivaganga','Virudhunagar','Namakkal','Cuddalore','Nagapattinam','Villupuram','Perambalur','Ariyalur','Karur','Krishnagiri','Dharmapuri','Kancheepuram','Chengalpattu','Tiruvallur','The Nilgiris','Tiruvannamalai','Kallakurichi','Pudukkottai','Ramanathapuram','Tenkasi','Tirupattur','Mayiladuthurai'].map(d => <option key={d} value={d} />)}
                          </optgroup>
                        </datalist>
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Highest Qualification</span>
                        <input
                          name="highest_qualification"
                          value={form.highest_qualification}
                          onChange={handleChange}
                          placeholder="Enter your highest qualification"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          list="dl-qualification"
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Expecting Job</span>
                        <input
                          name="expecting_job"
                          value={form.expecting_job}
                          onChange={handleChange}
                          placeholder="Enter your target job role"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          list="dl-job"
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Department</span>
                        <input
                          name="department"
                          value={form.department}
                          onChange={handleChange}
                          placeholder="Enter department"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          list="dl-department"
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Section</span>
                        <input
                          name="section"
                          value={form.section}
                          onChange={handleChange}
                          placeholder="Enter section"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-200"
                          list="dl-section"
                          required
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Resume (PDF/JPG)</span>
                        <input
                          type="file"
                          name="resume"
                          onChange={handleChange}
                          accept="application/pdf,.pdf,.jpg,.jpeg,image/jpeg,image/jpg"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-sm text-black outline-none file:mr-3 file:rounded-xl file:border-0 file:bg-yellow-400 file:px-4 file:py-2 file:font-bold file:text-black hover:file:bg-yellow-300"
                        />
                      </label>
                      <label className="block">
                        <span className="text-sm font-bold text-black">Photo (JPG)</span>
                        <input
                          type="file"
                          name="photo"
                          onChange={handleChange}
                          accept="image/jpeg,image/jpg"
                          className="mt-1.5 w-full rounded-2xl border border-gray-300 bg-gray-50 px-4 py-3 text-sm text-black outline-none file:mr-3 file:rounded-xl file:border-0 file:bg-yellow-400 file:px-4 file:py-2 file:font-bold file:text-black hover:file:bg-yellow-300"
                        />
                      </label>
                    </div>

                    {/* ── Datalists for searchable fields ── */}
                    <datalist id="dl-place">
                      {KERALA_PLACES.map((p) => <option key={p} value={p} />)}
                    </datalist>
                    <datalist id="dl-qualification">
                      {QUALIFICATIONS.map((q) => <option key={q} value={q} />)}
                    </datalist>
                    <datalist id="dl-job">
                      {JOB_ROLES.map((j) => <option key={j} value={j} />)}
                    </datalist>
                    <datalist id="dl-department">
                      {DEPARTMENTS.map((d) => <option key={d} value={d} />)}
                    </datalist>
                    <datalist id="dl-section">
                      {(DEPT_SECTIONS[form.department] || ALL_SECTIONS).map((s) => <option key={s} value={s} />)}
                    </datalist>
                  </div>
                  <div className="shrink-0 border-t border-gray-200 bg-white px-4 py-4 md:px-6">
                    <div className="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-3">
                      <p className="text-sm text-gray-600">Complete all required fields before submitting your profile.</p>
                      <div className="flex items-center justify-end gap-3">
                        <button
                          type="button"
                          onClick={closeRegisterModal}
                          className="rounded-xl border border-gray-300 px-5 py-3 text-sm font-bold text-black hover:border-yellow-400 hover:text-yellow-600 transition"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          disabled={loading}
                          className="rounded-xl bg-yellow-400 px-6 py-3 text-sm font-extrabold text-black hover:bg-yellow-500 transition disabled:opacity-60"
                        >
                          {loading ? 'Saving...' : 'Save Registration'}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showSuccessDialog && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 px-4 backdrop-blur-sm">
          <div className="relative w-full max-w-xl overflow-hidden rounded-[32px] border border-yellow-300/60 bg-[radial-gradient(circle_at_top_left,rgba(250,204,21,0.35),transparent_34%),linear-gradient(145deg,#fffdf5_0%,#ffffff_45%,#fff5cc_100%)] p-8 shadow-[0_35px_90px_rgba(0,0,0,0.28)]">
            <div className="absolute -right-12 -top-12 h-36 w-36 rounded-full bg-yellow-300/40 blur-3xl" />
            <div className="absolute -bottom-16 -left-10 h-40 w-40 rounded-full bg-black/10 blur-3xl" />
            <div className="relative">
              <div className="inline-flex h-16 w-16 items-center justify-center rounded-2xl border border-yellow-400/60 bg-black text-3xl text-yellow-300 shadow-lg">
                ✓
              </div>
              <p className="mt-6 text-xs font-extrabold uppercase tracking-[0.35em] text-yellow-600">Registration Received</p>
              <h3 className="mt-3 text-3xl font-black leading-tight text-black md:text-4xl">Thank You for the Registration</h3>
              <p className="mt-4 text-base leading-8 text-gray-700 md:text-lg">
                Our Team Member Dani will contact you shortly.
              </p>
              <p className="mt-3 text-sm leading-6 text-gray-600">
                Your profile has been submitted successfully. Please keep your phone available for the follow-up call.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="rounded-2xl border border-black/10 bg-white/80 px-4 py-3 text-sm font-semibold text-gray-700 shadow-sm">
                  Dani Job Club will review your details and reach out soon.
                </div>
                <button
                  type="button"
                  onClick={() => setShowSuccessDialog(false)}
                  className="rounded-xl bg-yellow-400 px-6 py-3 text-sm font-extrabold text-black hover:bg-yellow-500 transition"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Router>
  );
}

export default App;
